import React from "react";
import OrdersTab from "../OrdersTab/OrdersTab";
import AnalyzeButton from "../../components/AnalyzeButton/AnalyzeButton";
import { ABAS, TABS } from "../../config/tabs";

const ALERT = {
  severity: "info",
  message:
    "Recebemos a confirmação de entrega para os pedidos abaixo, mas eles não saíram da loja. O SAL está analisando o caso.",
};

export default function UnderReviewPage(props) {
  return (
    <OrdersTab
      {...props}
      alert={ALERT}
      aba={ABAS.EM_ANALISE}
      gaTab={TABS.EM_ANALISE}
      gaCountKey="emAnalise"
      renderActions={() => <AnalyzeButton disabled />}
    />
  );
}
